{
  "common": {
    "ok": "OK!",
    "cancel": "Cancel",
    "back": "Back",
    "next": "Next",
    "submit": "Submit",
    "app": "App",
    "downloadApp": "Download the app",
    "newIdeas": "New Ideas",
    "logout": "Logout",
    "confirm": "Confirm",
    "label": "%{label}",
    "yes": "Yes",
    "yesContinue": "Yes, continue",
    "no": "No",
    "off": "Off",
    "noThanks": "No, thanks",
    "skip": "Close",
    "seconds": "seconds",
    "beforeWeBegin": "before we begin",
    "gameStartsIn": "Game Starts In",
    "gameResumesIn": "Game Resumes In",
    "gamePaused": "Game Paused",
    "gameResumed": "Game Resumed",
    "dealingNextHand": "Dealing next hand in",
    "startNow": "Start Now",
    "resumeGame": "Resume Game",
    "gameIsPaused": "Game is paused",
    "onlyOnePlayerActive": "Only one player active",
    "startingGame": "Starting game...",
    "buyingChips": "A player is purchasing more chips",
    "rebuyLimitReached": "Sorry, no rebuys are available in this game.",
    "somethingWentWrong": "Something went wrong. Please try again.",
    "sidepotPlayers": "%{playerNames} split the pot with",
    "player": "Player",
    "game": "GAME",
    "games": "GAMES",
    "logoutConfirmation": "Are you sure you want to logout?",
    "observe": "Observe",
    "play": "Play",
    "modules": "POKER",
    "singleSidepotWinner": "Sidepot Winner",
    "multiSidepotWinner": "Sidepot Winners",
    "leaveGame": "Leave Game",
    "gotoSettings": "go to settings",
    "openInBrowser": "Open in Browser",
    "nevermind": "Nevermind",
    "signUp": "Sign Up",
    "refer": "Refer a Friend",
    "tableTour": "Open Table Tour",
    "cheatSheet": "Open Cheat Sheet",
    "welcomeMsg": "Welcome, %{name}.",
    "welcomeBackMsg": "Welcome back, %{name}.",
    "edit": "Edit",
    "done": "Done",
    "verify": "Verify",
    "phone": "Phone",
    "code": "Code",
    "login": "Log In",
    "sendCode": "Send Code",
    "error": "Error",
    "loading": "Loading...",
    "goBack": "Go back"
  },
  "button": {
    "addNewContact": "Add new contact",
    "addNew": "Addnew"
  },
  "drawer": {
    "about": "About Poker Power",
    "admin": "Admin",
    "book": "Book your Strategy Lesson",
    "community": "Community",
    "fourColorHide": "Hide 4-Color Deck",
    "fourColorShow": "Show 4-Color Deck",
    "gameDetails": "Game Settings",
    "handRankings": "Hand Rankings",
    "leaderboard": "View Leaderboard",
    "logout": "Logout",
    "notifications": "Notifications",
    "privacy": "Privacy Policy",
    "shop": "Shop",
    "sounds": "Sounds & Haptics",
    "sounds_web": "Sounds",
    "support": "Support",
    "terms": "Terms of Service"
  },
  "errors": {
    "name": "Please enter name",
    "email": "Please enter email",
    "validEmail": "Please enter valid email",
    "phoneNumber": "Please enter valid phone number",
    "dob": "Please enter valid date of birth",
    "gender": "Please select gender",
    "address": "Please enter address",
    "spendGift": "Please enter gift amount"
  },
  "banner": {
    "bannerText": "We can't reach our network right now. Please check your connection.",
    "noInternetConnection": "No Internet Connection",
    "dismiss": "Dismiss"
  },
  "splash": {
    "letsGo": "Let's go!"
  },
  "signup": {
    "email": "Your email",
    "phoneNumber": "Phone number",
    "dob": "Date of birth",
    "gender": "Gender",
    "newsOrDeals": "Sign up for news/deals",
    "sendingCode": "sending code...",
    "male": "Male",
    "female": "Female",
    "yes": "Yes",
    "no": "No",
    "googleSignin": "Sign in with Google ",
    "appleSignin": "Sign in with Apple ",
    "emailSignin": "Sign in with Email ",
    "phoneSignin": "Sign in with Phone ",
    "bottomText": "By proceeding, you acknowledge that you have \naccepted our ",
    "termsOfUse": "Terms of Use",
    "privacyPolicy": "Privacy Policy.",
    "and": " and ",
    "onboardingMsg1": "Discover the\npoker game that\nopens up new life\nskills with every\nhand.",
    "onboardingMsg2": "Where women+\nlearn to take\nrisks and win big,\nat the table and\nbeyond.",
    "onboardingMsg3": "No money or\ngambling, Get\nready to go all in\n- on you.",
    "phonePlaceholder": "Please enter the phone number",
    "password": "Password",
    "emailPlaceholder": "Enter your email",
    "passwordPlaceholder": "Enter your password",
    "googleLogin": "Continue with Google",
    "appleLogin": "Continue with Apple",
    "openMyEmailApp": "Open my email app",
    "saveNewPassword": "Save new password"
  },
  "liveEventScreen": {
    "question1": "Are you at a Poker Power",
    "question2": "live event ",
    "question3": "right now?",
    "noImNot": "No, I’m not",
    "yesImLive": "Yes, I’m at a live event",
    "pokerNameQuestion": "Create a poker name",
    "pokerNamesubtitle": "Your poker name is visible during game play and chat. Have fun with it!"
  },
  "whereAreYouScreen": {
    "title": "Where are you joining Poker Power from?"
  },
  "homeScreen": {
    "quickGame": "Quick Game",
    "tournament": "Tournament",
    "message": "What game do you want to create?",
    "takeVitualLesson": "Take virtual lessons",
    "virtualClassSubHeading": "Explore expert-taught lessons\non our website",
    "referMsg": "Invite Your Friends",
    "learnPoker": "Learn Poker",
    "cheatSheetMsg": "Hand Rankings",
    "playAGame": "PLAY A GAME",
    "startALesson": "Learn the Basics",
    "startALessonDescription": "There are infinite ways to play every hand, but let’s start with the basics if you aren’t quite ready.",
    "yourPlayStreak": "YOUR PLAY STREAK",
    "joindescription": "Dive into community fun. Find a table and start playing instantly.",
    "createdescription": "Be the host. Invite your friends to join your table.",
    "Practicedescription": "Master your skills. Play against bots to hone your poker prowess.",
    "newsLetter": "News Letter",
    "dailyPokerish": "Daily 3-Card Pokerish",
    "dailyPokerishShort": "Daily 3-Card",
    "seeResultsPokerish": "See results",
    "notCompletedPokerish": "Next daily game"
  },
  "createGameScreen": {
    "title": "Create Game",
    "subtitle": "Host a game and invite people to join.",
    "quickGame": {
      "title": "Quick Game",
      "item1": "Blinds never increase",
      "item2": "Add more chips anytime",
      "item3": "Leave anytime"
    },
    "tournament": {
      "title": "Tournament"
    },
    "custom": {
      "title": "Custom Game",
      "item1": "Schedule a tournament for later",
      "item2": "Share invite link with players",
      "item3": "Plays down to one winner"
    }
  },
  "joinLiveGameScreen": {
    "quickGame": {
      "title": "Join a Quick Game"
    },
    "tournament": {
      "title": "Join an Open Tournament"
    }
  },
  "userRoleScreen": {
    "question": "I want to join the game as",
    "teacher": "Teacher",
    "player": "Player",
    "joinFailed": "Failed to join the game. Please try again.",
    "joinFailedFull": "This game is full.",
    "joinFailedEnded": "This game has already ended.",
    "teacherSeatTaken": "Another teacher is already seated. Joining as an observer."
  },
  "practiceGameScreen": {
    "title": "Play a Practice\n Game",
    "description": "Select the number of bots you\n want to play against.",
    "startingChips": "Starting Chips",
    "blindsIncrease": "Would you like to increase blinds?",
    "blindSelectionMsg": "Select the number of minutes below.",
    "play": "Play"
  },
  "verifyCodeScreen": {
    "header": "Enter the code sent to",
    "resendCode": "Resend code"
  },
  "syncAccountScreen": {
    "headerLine1": "For a better experience,",
    "headerLine2": "link your accounts",
    "calendar": "Calendar",
    "contacts": "Contacts"
  },
  "addressbooks": {
    "syncAllCont": "Sync all contacts",
    "addCont": "Add contact"
  },
  "memberForm": {
    "header": "Member form",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "dob": "Date of birth",
    "gender": "Gender",
    "address": "Address",
    "spendOnGift": "Preffered spend on gift",
    "placeholderName": "First Last name",
    "placeholderEmail": "email@address.com.au",
    "placeholderPhone": "+61 40 123 456",
    "placeholderAdd": "30 Regent St, 3121 VIC",
    "pokerNameQuestion": "Create a poker name",
    "pokerNamesubtitle": "Your poker name is visible during game play and chat. Have fun with it!"
  },
  "category": {
    "header1": "Select three categories",
    "header2": "you would like."
  },
  "contacts": {
    "headerName": "Contacts",
    "nextGiftDate": "Next gifting date",
    "days": "DAYS"
  },
  "contactDetails": {
    "headerAge": "years old -",
    "needToFind": "I NEED TO FIND"
  },
  "selectGift": {
    "chooseGift": "Choose gift",
    "for": "for"
  },
  "savedGiftScreen": {
    "savedGift": "Saved gift"
  },
  "profileScreen": {
    "referMsg": "Refer 1 friend to \nunlock your next \nBonus Lesson",
    "achievementMsg": "Play games and refer friends to Poker \nPower to earn achievements",
    "superGiftStatus": "Super Gifter Status",
    "personal": "Personal",
    "address": "Address",
    "credentials": "Credentials",
    "saveProfile": "Save Profile",
    "editProfile": "Edit Profile",
    "scheduleSectionTitle": "Schedule",
    "viewTeachingTablesCta": "View Tables",
    "teachingTablesCtaText": "Join a Teaching Table to get expert live-coaching during a poker game.",
    "email": "Email",
    "phoneNumber": "Phone number",
    "dob": "Date of birth",
    "gender": "Gender",
    "userId": "User ID",
    "channelName": "Channel Name",
    "gameId": "Game ID",
    "status": "Status",
    "stats": "STATS",
    "totalNumberOfHands": "Total Number Of Hands",
    "numberOfHandsPlayed": "Number Of Hands Played",
    "numberOfHandsWon": "Number Of Hands Won",
    "bestHandEverWon": "Best Hand Won",
    "biggestWin": "Biggest Win",
    "preflopFold": "Pre-Flop Fold %",
    "currentGame": "Current Game",
    "history": "History",
    "profile": "Profile",
    "myStats": "My Stats",
    "communityGame": "Community Game",
    "quickPlayGame": "Quick Play Game",
    "deleteAccount": "Delete Account",
    "deleteConfirmation": "Are you sure you want to delete your account?",
    "achievement": "ACHIEVEMENTS",
    "accountInfo": "ACCOUNT INFO",
    "handsDealt": "Hands Dealt",
    "handsPlayed": "Hands played",
    "handswon": "Hands won",
    "referrals": "Referrals",
    "preflopFolds": "Pre-flop folds",
    "playHistory": "Play History",
    "verificationCode": "Verification code",
    "emailVerification": "Email Verification",
    "placeholder": "Please enter the verification code",
    "nothingScheduled": "Nothing scheduled"
  },
  "editProfileScreen": {
    "nameQuestion": "What's your name?",
    "nameLabel": "Name",
    "namePlaceholder": "Enter the name",
    "emailQuestion": "What's your email?",
    "emailLabel": "Email",
    "emailPlaceholder": "Enter the email"
  },
  "myGiftCategory": {
    "header": "My gifts category"
  },
  "selectGiftForMyself": {
    "header": "Choose a gift for myself"
  },
  "thankYouScreen": {
    "thankyou": "Thank you!",
    "yourPrefernceWere": "Your preferences were",
    "submitted": "successfully submitted."
  },
  "welcomeScreen": {
    "poweredBy": "POWERED BY BOWSER",
    "readyForLaunch": "Ready for launch.",
    "continue": "CONTINUE"
  },
  "demoScreen": {
    "howTo": "HOW TO",
    "title": "What’s In This Stack?",
    "tagLine": "Congratulations, you’ve got a very advanced React Native app template here.  Take advantage of this boilerplate!",
    "reactotron": "Demo Reactotron",
    "androidReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running, run adb reverse tcp:9090 tcp:9090 from your terminal, and reload the app.",
    "iosReactotronHint": "If this doesn't work, ensure the Reactotron desktop app is running and reload app."
  },
  "playerActionHints": {
    "BLANK": "",
    "FOLD": "FOLD",
    "CHECK": "CHECK",
    "BET": "BET",
    "RAISE": "RAISE",
    "CALL": "CALL",
    "ALLIN": "ALL IN",
    "PREFOLD": "Prefold",
    "UNDOFOLD": "Undo fold"
  },
  "storybook": {
    "placeholder": "Placeholder",
    "field": "Field"
  },
  "gameWinningHand": {
    "Royal Flush": "a Royal Flush",
    "Straight Flush": "a Straight Flush",
    "Four of a Kind": "Four of a kind",
    "Full House": "a Full House",
    "Flush": "a Flush",
    "Straight": "a Straight",
    "Three of a Kind": "Three of a kind",
    "Two Pair": "Two Pair",
    "Pair": "Pair",
    "High Card": "a High Card",
    "allFolds": "{name} WINS EVERYONE FOLDED"
  },
  "lobbyScreen": {
    "createGameButtonMeassage": "Create a table, invite your friends and play",
    "inviteByCodeMessage": "Have a game invitation code? TAP HERE",
    "createPracticeGameMessage": "Play against the computer",
    "tapHere": "Tap Here",
    "community": "COMMUNITY",
    "communityGameMessage": "Visit the lobby and join a table",
    "miniGameMessage": "Learn how to play poker with our collection of games",
    "learning": "LEARN POKER",
    "zoomClass": "Register for virtual classes"
  },
  "miniGamesScreen": {
    "title": "Mini Games",
    "introScreen": {
      "startGameButton": "GET STARTED"
    },
    "finalScreen": {
      "title": "Score",
      "playAgainButton": "PLAY AGAIN"
    },
    "gamePreviewCard": {
      "playButton": "Play"
    },
    "allRankingsTitle": "Best Hands",
    "versusScreen": {
      "warGame": {
        "opponentCards": "Opponent cards",
        "playerCards": "Player cards",
        "timer": "Let's get started!",
        "playerWins": "You win!",
        "opponentWins": "Opponent Wins!",
        "warStart": "War!"
      }
    }
  },
  "linearText": {
    "joinGame": "JOIN GAME",
    "practice": "PRACTICE",
    "createGame": "CREATE GAME",
    "miniGame": "MINI GAMES",
    "registerForZoomClass": "VIRTUAL CLASS"
  },
  "join": {
    "enterCodeMessage": "Enter a game code to join",
    "gameCodeError": "GAME NOT FOUND",
    "errorInvalidCode": "Please enter a valid 6-character game code",
    "errorNotLoggedIn": "You must be logged in to join a game",
    "errorNoCode": "Please enter a game code",
    "errorGameEnded": "This game has already ended",
    "errorGameFull": "All Seats are presently taken at this table",
    "errorGameNotFound": "Game not found",
    "join": "Join Game",
    "confirmMessageBeforeJoinTheTable": "I want to join a game to",
    "inputCodeMsg": "Enter your invitation code\n or Community Games password\nto start playing.",
    "joinScreenHeading": "Join a Game",
    "noCodeMessage": "No code? You can click here to join a table.",
    "joinOpenGame": "Join an open game",
    "openTable": "Open Tables",
    "openTableDiscription": "Live games. Anytime, anywhere. ",
    "privateTables": "Private Tables",
    "privateTablesDiscription": "Enter your invitation code or \ncommunity games password to start \nplaying",
    "upcomingCommunityTable": "Upcoming Community Tables",
    "schedule": "See the entire schedule >"
  },
  "informationGameOver": {
    "runtime": "Runtime",
    "prizePool": "Prize Pool"
  },
  "newGameScreen": {
    "common": {
      "winners": "Winners",
      "mainPot": "Main Pot",
      "sidePot": "Side Pot",
      "sidePotsTitle": "Side Pots",
      "sidePots": "A side pot is formed when a player goes all-in with fewer chips than others, allowing additional betting among the remaining players. The all-in player can only win the portion of the pot they contributed to.",
      "waitingForGame": "WAITING FOR GAME",
      "waitingForPlayers": "WAITING FOR PLAYERS",
      "startChatting": "Start Chatting",
      "walkthrough": "Your seat",
      "yourTurn": "Your Turn"
    },
    "threeCardPoker": {
      "actionHints": {
        "BET": "Bet",
        "CALL": "Match",
        "CHECK": "Check",
        "FOLD": "Fold this hand",
        "RAISE": "Raise",
        "ALLIN": "Raise All"
      }
    },
    "player": {
      "actionHints": {
        "ALLIN": "All In",
        "BET": "Bet",
        "BLANK": "",
        "CALL": "Call",
        "CHECK": "Check",
        "FOLD": "Fold",
        "RAISE": "Raise",
        "allin": "All In",
        "bet": "Bet",
        "call": "Call",
        "check": "Check",
        "fold": "Fold",
        "raise": "Raise"
      },
      "lastAction": {
        "active": "ACTIVE",
        "allin": "All In",
        "folded": "Fold",
        "foreverout": "Sitting",
        "out": "Out",
        "sitout": "Sitting",
        "sittingout": "Sitting Out",
        "waiting": "Waiting",
        "ALLIN": "All In",
        "BET": "Bet",
        "BIGBLIND": "BB",
        "BLIND": "BLIND",
        "CALL": "Call",
        "CHECK": "Check",
        "FOLD": "Fold",
        "RAISE": "Raise",
        "SMALLBLIND": "SB",
        "SITTINGOUT": "Sitting Out",
        "HOLA": "HOLA",
        "HI": "HI!",
        "HELLO": "HELLO",
        "HEY": "HEY",
        "WAITING": "WAITING"
      },
      "lastActionForPlayer": {
        "allin": "You are All In!",
        "folded": "You folded",
        "foreverout": "You are currently sitting out",
        "out": "Thanks for playing",
        "sitout": "You are currently sitting out",
        "sittingout": "You are sitting out",
        "waiting": "You are waiting",
        "ALLIN": "You are All In!",
        "BET": "You bet",
        "BIGBLIND": "BB",
        "CALL": "You called",
        "CHECK": "You checked",
        "FOLD": "You folded",
        "RAISE": "You raised",
        "SMALLBLIND": "SB"
      },
      "lastActionForPlayerConvex": {
        "allin": "You are All In!",
        "folded": "You folded",
        "out": "Thanks for playing",
        "sittingout": "You are sitting out",
        "waiting": "You are waiting",
        "bet": "You bet",
        "call": "You called",
        "check": "You checked",
        "fold": "You folded",
        "raise": "You raised",
        "BIGBLIND": "Big Blind",
        "SMALLBLIND": "Small Blind"
      },
      "states": {
        "observing": "You're an observer",
        "teacherMode": "You're in teacher mode"
      }
    },
    "betModalError": {
      "minimunRaiseError": "There was an error calculating minimum raise!",
      "betLowerThanMinimunRaiseError": "The minimum %{kind} amount is %{minimumRaise}",
      "betBiggerThanChipStackError": "You don't have enough chips!",
      "betLowerThanBigBlindError": "Your bet cannot be lower than Big Blind (%{bigBlind})",
      "betLowerThanBiggestBetError": "Your bet cannot be lower than the current biggest bet (%{biggestBet})"
    },
    "toast": {
      "allIn": "is all in!",
      "gameDeleted": "Game Deleted",
      "gamePaused": "Game Paused",
      "gameResumed": "Game Resumed",
      "startingGame": "Game starts in",
      "gameOver": "Game Over"
    }
  },
  "blindsTable": {
    "next": "Next",
    "current": "Current",
    "blinds": "Blinds"
  },
  "gameScreen": {
    "observerNotice": "You're observing this game.",
    "observerBackToLobby": "Back to Lobby",
    "observerLeave": "Leave",
    "formattedNumber": "%{value}",
    "playerRoleOrName": "%{value}",
    "playerAction": "%{action}",
    "defaultName": "Player %{index}",
    "sittingOut": "SITTING OUT",
    "out": "OUT",
    "foreverOut": "FOREVER OUT",
    "watching": "WATCHING",
    "observer": "OBSERVER",
    "numberOfSidePots": "%{count, plural, =1 {count side pot} other {# side pots};}",
    "singleSidePot": "1 side pot",
    "multipleSidePots": "%{count} sidepots",
    "playerNameList": "%{playerNames} and %{lastPlayerName}",
    "gameDeletedTitle": "Game is deleted",
    "gameDeletedMessage": "Game was ended.",
    "gameDeletedMessageReturn": "Taking you back to Play tab now",
    "removedFromGameByTeacher": {
      "title": "The teacher removed you from this table.",
      "messageReturn": "Taking you back to Play tab now",
      "goToPlay": "Go to Play"
    },
    "terminateGameMessage": "Do you want to terminate the game?",
    "confirmMessageBeforeLeavingGame": "Are you sure you want to leave the game?",
    "confirmMessageBeforeDeletingAccount": "WARNING: Are you sure you want to delete your account and data?",
    "joinGameUnableTitle": "Unable to join another game",
    "joinGameUnableMessage": "Leave your current game before joining other.",
    "joinVideoCall": "Choose to join call with or without video:",
    "videoCall": "Video Call",
    "audioCall": "Audio Only",
    "fullTable": "This table is full.",
    "leaveGame": "Leave Game",
    "deleteAccount": "Delete Account",
    "supportConfirmation": "Send debug information to support?",
    "optionModal": {
      "joinVideoCall": "Choose to join call with or \nwithout video",
      "leaveVideoCall": "Leave Call",
      "mute": "Mute",
      "unmute": "Unmute",
      "hideVideo": "Hide Video",
      "showVideo": "Show Video"
    },
    "status": {
      "allInOrWinning": "%{status}",
      "called": "%{status} CALLED",
      "raised": "%{status} RAISED",
      "folded": "%{status} FOLDED"
    },
    "betModal": {
      "betInputHeading": "BET INPUT",
      "dialNumber": "%{number}",
      "numberEntry": "Number Entry",
      "manualEntry": "Manual Entry",
      "suggestedBet": "Suggested Bet",
      "maxBetAmountError": "You can only bet %{maxAmount}",
      "minRaiseAmountError": "Minimum %{betKind} should be %{minAmount}"
    },
    "actionModal": {
      "title": "%{message} %{stackValue}"
    },
    "PlayerOutOfChipsMessage": "Congratulations! You placed %{rank}%{suffix} in the tournament.",
    "PracticeMode": {
      "endPracticeGameModalMessage": "Do you want to continue playing?"
    },
    "appPermission": "Please enable the camera and mic access from settings",
    "waitingForHostToStart": "Waiting for host to start the game",
    "startingIn": "Starting in %{time}",
    "leaveGameModal": {
      "title": "Leave Game?",
      "message": "This game can be saved for later or deleted.",
      "saveForLater": "Save for Later",
      "endGame": "End Game",
      "leaveOnly": "Leave Game",
      "close": "Close"
    },
    "teacherViewingCardsToast": {
      "allPrivate": "Teacher is viewing cards",
      "allPublic": "Teacher is viewing cards (public)",
      "yourCards": "Teacher is viewing your cards",
      "playerCards": "Teacher is viewing %{name}'s cards",
      "playersCards": "Teacher is viewing %{count} players' cards"
    },
    "sittingOutModal": {
      "title": "You're Sitting Out",
      "message": "You didn't respond for two hands. Return to rejoin on the next hand, or leave the game.",
      "returnToGame": "Return to Game",
      "leaveGame": "Leave Game"
    },
    "buyChip": {
      "title": "You’ve run out of chips.",
      "subtitle": "Buy in %{amount}?"
    },
    "endPracticeGame": {
      "title": "Bravo! Victory is yours!",
      "subtitle": "Do you want to start a new game?"
    },
    "quickGameOver": {
      "title": "Game Over!",
      "message": "Great game! View your stats to see how you did.",
      "viewStats": "View Stats",
      "goToLounge": "Go to Lounge",
      "goToPlay": "Go to Play",
      "goToHome": "Go to Home"
    },
    "postGameStatistics": {
      "leavingGame": "Leaving game...",
      "goToPlayTab": "Go to Play tab",
      "goToLounge": "Go to Lounge"
    },
    "gameInfo": {
      "hand": "Hand",
      "blinds": "Blinds",
      "blindTimer": "Blind Timer",
      "nextBlind": "Next Blind"
    }
  },
  "adminGameScreen": {
    "howToDismissMessage": "Click outside this area to dismiss.",
    "gridPresetTitle": "Grid Preset (show table)",
    "lottieAnimationTitle": "Enable Lottie Animation",
    "agoraVideoTitle": "Enable Agora Video",
    "fourColoredDeckTitle": "Enable Four Color Deck",
    "gameJoined": "Game Joined",
    "gameDeleted": "Game Deleted",
    "noGameFound": "No game found",
    "gameTitle": "%{playerName}'s with %{hashCode}",
    "gameDescription": "%{gameId} %{currentGameStatus}",
    "gameAutostart": "Game Autostart",
    "onboardingDataCleared": "Onboarding data cleared"
  },
  "adminMessageScreen": {
    "howToDismissMessage": "Click outside this area to dismiss.",
    "toast": "Toast",
    "sortMessage": "Sort Messages",
    "showSnackbar": "Show Snackbar"
  },
  "adminEnvironmentScreen": {
    "envTitle": "Current env (%{env})",
    "envSubtitle": "Toggle from %{fromEnv} to %{toEnv}",
    "appStateSnapshot": "Application State Snapshot"
  },
  "gameWaitingRoom": {
    "maximumSeats": "Maximum Number of Seats",
    "buyInAmount": "Buy-in Amount",
    "numberOfRebuys": "Number of Rebuys",
    "actionTime": "Action Time",
    "blingInterval": "Bling Interval",
    "smallBlind": "Small Blind",
    "bigBlind": "Big Blind",
    "observers": "Observers",
    "heading": "Game Lobby",
    "lobbyTab": "Lobby",
    "rulesTab": "Rules",
    "startGame": "Start Game",
    "rebuyTime": "Rebuy Time"
  },
  "teacherOptions": {
    "unseatPlayer": "Unseat Player",
    "muteAll": "Mute All",
    "unmuteAll": "Unmute All",
    "sitOut": "Sit Out",
    "removePlayer": "Remove Player",
    "imBack": "I'm Back",
    "leaveGame": "Leave Game",
    "stepAway": "Step Away"
  },
  "teacherControls": {
    "removePlayer": {
      "title": "Remove Player",
      "confirmMessage": "Remove %{name} from the game?",
      "confirmHint": "They can rejoin if they have the game code.",
      "remove": "Remove"
    }
  },
  "nameScreen": {
    "nameMsg": "Your name in game will be",
    "next": "Next",
    "startPlaying": "Start Playing",
    "welcomePokerPower": "Welcome to \nPoker Power",
    "description": "Experience the card game that\nteaches you new life skills with every\nhand. Play Texas Hold ‘Em with your\nfriends, learn from women+ experts,\nand go all in."
  },
  "roundWinner": {
    "return": "Return to Game"
  },
  "handWinner": {
    "text": "wins ",
    "youText": "won "
  },
  "blinds": {
    "blinds": "BLINDS",
    "time": "%{minutes}:%{seconds}",
    "current": "Current: ",
    "next": "Next: ",
    "currentBlindValues": "%{smallBlind}/%{bigBlind}",
    "nextBlindValues": "%{smallBlind}/%{bigBlind}"
  },
  "activeGameScreen": {
    "seatsLeft": "%{seats} Seats Available",
    "register": "REGISTER",
    "observer": "OBSERVE",
    "gameOver": "GAME OVER",
    "activeGame": "Community Games",
    "deleteConfirmation": "You want to delete this game?",
    "noCurrentGame": "No current games",
    "viewSchedule": "View Schedule"
  },
  "loungeGameSettingsScreen": {
    "gameName": "Game Name",
    "blindLength": "Blind Length",
    "startingChips": "Starting Chips",
    "actionLength": "Action Length",
    "time": "Time",
    "schedule": "Schedule",
    "repeat": "Repeat",
    "never": "Never",
    "everyDay": "Every Day",
    "saveChanges": "Save Changes",
    "deleteGame": "Delete Game",
    "notFound": "Game not found or no longer active.",
    "nameRequired": "Game name required",
    "repeatDaysRequired": "Select at least one day to set up a recurring game",
    "saveFailed": "Failed to save changes",
    "deleteFailed": "Failed to delete game",
    "errorTitle": "Something went wrong",
    "deleteAlert": {
      "title": "Delete Game",
      "message": "Are you sure you want to delete this game? This cannot be undone.",
      "cancel": "Cancel",
      "confirm": "Delete"
    }
  },
  "createTournamentScreen": {
    "title": "Tournament",
    "editTitle": "Edit Game",
    "formTitle": "Table Settings",
    "createButton": "Create Game",
    "editButton": "Save Changes",
    "name": "Game Name",
    "blindsLength": "Blinds Length",
    "startingChips": "Starting Chips",
    "actionTime": "Action Length",
    "schedule": "Schedule for later",
    "difficulty": "Difficulty",
    "accessControl": "Access Control",
    "date": "Date",
    "time": "Time",
    "nameTooLong": "Maximum length is %{length} characters"
  },
  "communityGamesPassword": {
    "heading": "Community Games Password",
    "proceed": "Proceed",
    "invalidPassword": "Invalid Password",
    "communityDescription": "Community Games are for those who have taken Poker Power classes for additional practice. The password can be found on our Player Resources page or ask your teacher! Sign up for classes here on the ",
    "pokerWebsite": "Poker Power Website."
  },
  "chatDealerMessages": {
    "playerFolded": "has folded.",
    "playerChecked": "has checked.",
    "playerCalled": "has called.",
    "playerAllIn": "has gone all in!",
    "playerBet": "has bet",
    "playerRaised": "has raised to",
    "playerWonWith": "has won with",
    "playerWentOutWith": "went out with",
    "playerWon": "has won",
    "playerPaused": "has paused the game.",
    "playerUnpaused": "has unpaused the game.",
    "playerShowCards": "has shown player cards.",
    "playerHideCards": "has hidden player cards.",
    "playerTimedOut": "has timed out.",
    "playerWonTournament": "won the tournament!"
  },
  "gameDetails": {
    "title": "Game Settings",
    "cardColors": "Card Colors",
    "numberOfBots": "# of Bots",
    "startingChips": "Starting Chips",
    "blinds": "Blinds",
    "turnClock": "Turn Clock",
    "blindIncreases": "Blind Increases",
    "rebuy": "Rebuy",
    "reentries": "Re-entries",
    "rebuyNone": "None",
    "rebuyUnlimited": "Unlimited",
    "teacherMode": "Teacher mode",
    "group": {
      "on": "On",
      "off": "Off"
    }
  },
  "leaderboard": {
    "leaderboardHeading": "Leaderboard",
    "myRank": "My Rank",
    "entries": "Entries",
    "runtime": "Runtime",
    "prizePool": "Prize Pool",
    "runtimeValue": "%{runtime}",
    "myRankValue": "%{rank}",
    "entriesValue": "%{entries}",
    "poolPrizeValue": "%{prizeValue}",
    "rank": "RANK",
    "stack": "Stack",
    "user": "PLAYER",
    "chips": "CHIPS",
    "name": "Name",
    "ra": "R+A",
    "totalChips": "Total Chips (LB State):  ",
    "totalChipsValue": "%{totalChipsValue}",
    "totalChipsFromTable": "Total Chips (Snapshot Table):  ",
    "totalChipsFromTableValue": "%{totalChipsFromTableValue}"
  },
  "socketState": {
    "closed": "Disconnected",
    "connecting": "Reconnecting...",
    "open": "Connected",
    "closing": " ",
    "unknown": " "
  },
  "surveyGameScreen": {
    "lingoLookup": "Lingo Lookup",
    "nextRound": "Next Round",
    "viewRankings": "View Rankings",
    "royalFlush": "Royal Flush",
    "fullHouse": "Full House"
  },
  "zogo": {
    "learningModulesTitle": "Learn Poker",
    "learningModule": {
      "accurracy": "Accuracy",
      "completedTimes": "Tries",
      "completedAt": "Completed at",
      "noCompletedYet": "Not completed yet, start learning now."
    },
    "completedModuleMessage": "Bravo!!\nyou completed the module"
  },
  "bots": {
    "count": "How many bots do you want to play against?"
  },
  "openTableScreen": {
    "quickGame": "Quick Game",
    "quickGameDescription": "A casual, Texas Hold 'Em Style game, where the blinds never increase and you can add more chips if you run out.",
    "tournamentStyle": "Tournament Style",
    "tournamentDescription": "Texas Hold 'Em where the blinds increase and you play down to one winner. ",
    "landingScreenText": "Looking for a\ntable... get ready\nto slay!"
  },
  "cheatSheet": {
    "heading": "What hands should I play?"
  },
  "newsLetter": {
    "sure": "Sure!",
    "notrightnow": "Not right now",
    "heading": "Want email updates about live events and new app features?",
    "greetMsg": "Hey, %{firstName}"
  },
  "realTimeUpdates": {
    "title": "Get real-time updates!",
    "itemOne": "Instant alerts on live games & tournaments",
    "itemTwo": "Important reminders & community updates",
    "itemThree": "Strategic tips & tricks"
  },
  "bottomNavigation": {
    "home": "Home",
    "play": "Play",
    "learn": "Learn",
    "read": "Read",
    "profile": "Profile",
    "premium": "Premium"
  },
  "outOfOrderSheet": {
    "title": "Wait a second...",
    "subtitle": "We recommend watching our lessons in chronological order.",
    "okayButton": "Okay",
    "ignoreButton": "Ignore and proceed anyway"
  },
  "completedChapter": {
    "title": "Congrats!",
    "subtitleChapter": "You've completed chapter",
    "subtitleLesson": "You've completed Lesson",
    "subtitleAllLessons": "You've completed all Lessons!",
    "autoplaying": "Autoplaying next chapter...",
    "autoplayingNextLesson": "Autoplaying next course...",
    "watchNow": "Watch Now",
    "returnTo": "Return to learn",
    "cancel": "Cancel"
  },
  "joinPremium": {
    "title": "Join Premium Today",
    "subtitle": "Unlock access to 40+ on-demand video lessons and exclusive access to our new community platform.",
    "getPremium": "Get Premium",
    "cancel": "Not right now",
    "profile": "Profile",
    "premium": "Premium",
    "titleGold": "Join Premium Gold",
    "subtitleSubscribe": "Subscribe to unlock access to live lessons.",
    "subscribe": "Subscribe"
  },
  "credits": {
    "title": "1 Lesson Credit",
    "subtitle": "You've used ",
    "subtitle2": " of 4 credits available this month",
    "register": "Register"
  },
  "gameType": {
    "community": "Community Game",
    "openTournament": "Open Tournament",
    "privateTournament": "Private Tournament",
    "openQuickGame": "Open Quick Game",
    "privateQuickGame": "Private Quick Game",
    "practice": "Practice Game"
  },
  "gameKind": {
    "quickGame": "Private Game",
    "tournament": "Private Game",
    "practice": "Practice Game",
    "communityGame": "Community Game",
    "openTable": "Live Game"
  },
  "gameMode": {
    "practice": "Practice Game",
    "private": "Private Game",
    "public": "Public Game",
    "community": "Community Game"
  },
  "loungeJoinScreen": {
    "invalidCode": "Oops! It looks like the code you entered isn't valid. Please try again.",
    "rejoinRequiresOwner": "Looks like you've been in this lounge before. To get back in, ask the lounge owner to invite you again.",
    "loungeInactive": "This lounge isn't active right now. Check with the lounge owner and try again later.",
    "genericError": "We couldn't join this lounge. Please try again in a moment.",
    "activeLounge": "Active lounge",
    "loungeUnavailable": "Lounge unavailable",
    "memberCount": "%{current} / %{max} members",
    "atCapacity": "This lounge is at capacity. Ask the owner for a new code or start your own lounge.",
    "joining": "Joining...",
    "loungeFull": "Lounge full",
    "joinLounge": "Join Lounge"
  },
  "loungeFullModal": {
    "title": "Sorry, the lounge is full",
    "body": "Every seat is taken. Sometimes the best move is to create your own table. Start a Lounge and invite your people.",
    "createLounge": "Create a Lounge"
  },
  "lounges": {
    "explainerTitle": "My Lounges",
    "emptyStateDescription": "Your table, your people, your moment. Create a private room, invite your crew, and play together, the way the game was meant to be played.",
    "joinALounge": "Join",
    "createALounge": "Create a Lounge",
    "joinALoungeTitle": "Join a Lounge",
    "joinALoungeDescription": "Enter your invite code or community games password to join a lounge.",
    "enterCode": "Enter Code",
    "somethingWentWrong": "Something went wrong.",
    "onlineCount": "%{count} Online"
  },
  "loungeChatTab": {
    "chatDisabled": "Chat has been disabled by the lounge admin."
  },
  "loungeLobbyScreen": {
    "join": "Join",
    "view": "View",
    "play": "Play",
    "chat": "Chat",
    "members": "Members",
    "upcomingGames": "Upcoming Games",
    "noUpcomingGames": "No upcoming games yet.",
    "scheduledGames": "Lounge Scheduled Games",
    "noScheduledGames": "No scheduled games in the next two weeks.",
    "createGame": "Create Game",
    "shareLounge": "Share the Lounge",
    "shareLoungeSubtitle": "Invite friends via messages or email.",
    "joinCode": "Join Code",
    "qrCode": "QR Code",
    "rotateCode": "Rotate Code",
    "rotating": "Rotating…",
    "copy": "Copy",
    "rotate": "Rotate",
    "editJoinCodeAccessibilityLabel": "Edit join code",
    "joinCodeAvailable": "✓  %{code} is available",
    "joinCodeTaken": "This code is already in use. Try a different one.",
    "joinCodeLimit": "You’ve hit the %{max}-character limit.",
    "joinCodeInvalidChars": "Use letters and numbers only. No spaces or symbols.",
    "joinCodeTooShort": "Use at least %{min} characters.",
    "joinCodeSaveError": "Couldn't update the join code. Please try again.",
    "copyCodeSuccess": "Join code copied to clipboard.",
    "copyCodeTitle": "Copied",
    "joinFull": "This game is full.",
    "joinUnavailable": "This game is no longer available.",
    "unableToJoin": "Unable to join",
    "membersCountSingular": "%{count} Member",
    "membersCountPlural": "%{count} Members",
    "membersStatusLabel": "STATUS",
    "membersStatusOnline": "Online",
    "membersStatusInGame": "In Game",
    "membersStatusOffline": "Offline",
    "memberSettings": "Member Settings",
    "makeOwner": "Make Lounge Owner",
    "makeCoOwner": "Make Lounge Co-Owner",
    "removeMember": "Remove Member",
    "makeOwnerConfirm": "Make Lounge Owner",
    "makeCoOwnerConfirm": "Make Lounge Co-Owner",
    "removeMemberConfirm": "Remove Member",
    "confirmCancel": "Cancel",
    "confirmConfirm": "Confirm"
  },
  "loungeSettingsScreen": {
    "leaveLounge": "Leave Lounge",
    "leaving": "Leaving...",
    "title": "Lounge Settings",
    "joinCode": {
      "sectionLabel": "JOIN CODE",
      "emptyPlaceholder": "—",
      "copyAccessibilityLabel": "Copy join code",
      "showQrAccessibilityLabel": "Show QR code",
      "qrCodeButton": "QR Code",
      "rotateAccessibilityLabel": "Rotate join code",
      "rotatingButton": "Rotating...",
      "rotateCodeButton": "Rotate Code",
      "qrDescription": "Scan to join this lounge on Poker Power."
    },
    "nav": {
      "brandingAndIdentity": "Branding & Identity",
      "brandingAndIdentityAccessibilityLabel": "Branding and identity",
      "configuration": "Configuration",
      "scheduledGames": "Scheduled Games"
    },
    "notifications": {
      "sectionLabel": "NOTIFICATIONS",
      "muteGames": "Mute game notifications"
    },
    "copiedTitle": "Copied",
    "copiedMessage": "Join code copied to clipboard.",
    "rotateAlert": {
      "title": "Rotate Code",
      "message": "This will invalidate the current join code. Continue?",
      "cancel": "Cancel",
      "confirm": "Rotate"
    },
    "leaveAlert": {
      "title": "Leave Lounge",
      "message": "Are you sure you want to leave this lounge?",
      "cancel": "Cancel",
      "confirm": "Leave"
    },
    "cannotLeaveTitle": "Cannot Leave",
    "cannotLeaveMessage": "Transfer ownership before leaving the lounge.",
    "leaveError": "Failed to leave lounge."
  },
  "loungeBrandingScreen": {
    "title": "Branding & Identity",
    "loading": "Loading...",
    "accessDenied": "Only owners can edit branding.",
    "loungeName": {
      "sectionLabel": "LOUNGE NAME",
      "placeholder": "Lounge name",
      "editAccessibilityLabel": "Edit name"
    },
    "description": {
      "sectionLabel": "SHORT DESCRIPTION (OPTIONAL)",
      "placeholder": "A short tagline for your lounge..."
    },
    "avatar": {
      "sectionLabel": "LOUNGE AVATAR",
      "uploadedLogoMessage": "Lounge avatar choosing is disabled. Your lounge is using an uploaded logo."
    },
    "tableColor": {
      "sectionLabel": "TABLE COLOR"
    },
    "errors": {
      "updateNameFailed": "Failed to update name.",
      "updateDescriptionFailed": "Failed to update description."
    }
  },
  "loungeConfigurationScreen": {
    "title": "Configuration",
    "loading": "Loading...",
    "accessDenied": "Only owners can edit configuration.",
    "chatSettings": {
      "sectionLabel": "CHAT SETTINGS",
      "enableTextChat": "Enable Text Chat",
      "chatRetention": "Chat Retention",
      "retentionDropdownLabel": "Select chat retention period"
    },
    "gamePermissions": {
      "sectionLabel": "GAME PERMISSIONS",
      "allowAdHocGames": "Allow Ad Hoc Games",
      "membersCanInvite": "Enable all members to invite others."
    },
    "alerts": {
      "sectionLabel": "ALERTS & NOTIFICATIONS",
      "enablePushNotifications": "Enable Push Notifications"
    },
    "errors": {
      "updateSettingsFailed": "Failed to update settings."
    }
  },
  "acceptScheduledTournamentScreen": {
    "title": "Tournament",
    "loading": "Loading...",
    "restrictedMessage": "This game is exclusive to lounge members. You need to be an active member of the lounge to join.",
    "addGame": "Add Game to my schedule",
    "adding": "Adding...",
    "joinGame": "Join Game Now",
    "joining": "Joining...",
    "joinError": "You need to be invited to this lounge to join this game."
  },
  "joinConfirmModal": {
    "inviteOnly": "You need to be invited to this lounge to join this game.",
    "loungeFull": "This lounge is full, so you can't join this game right now.",
    "genericError": "Something went wrong while joining the game. Please try again."
  },
  "teacherSeatChoice": {
    "title": "Choose your seat",
    "subtitle": "Where would you like to sit?",
    "teacherSeat": "Teacher seat",
    "teacherSeatDescription": "Sit as an observer and guide the table",
    "teacherSeatTakenBy": "%{name} is guiding the table. You'll watch as an observer",
    "playerSeat": "Player seat",
    "playerSeatDescription": "Take a seat and play hands",
    "tableFull": "The table is full",
    "genericError": "Something went wrong while changing seat. Please try again."
  },
  "scheduledGameCard": {
    "blindIncreaseEvery": "%{minutes} min blinds",
    "noBlindIncrease": "No blind increase"
  },
  "scheduledTournamentConfirmation": {
    "loading": "Loading...",
    "editGame": "Edit Game",
    "acceptedInvites": {
      "title": "Accepted invites",
      "countSingular": "%{count} player has accepted the invite",
      "countPlural": "%{count} players have accepted the invite"
    },
    "startGame": "Start Game",
    "starting": "Starting...",
    "deleteGame": "Delete game",
    "deleting": "Deleting...",
    "startNeedMorePlayers": "You need at least one other player to start. Share the invite link to get players!",
    "toastGameDeleted": "Scheduled game deleted.",
    "toastCodeCopied": "Code copied.",
    "shareMessage": "Challenge accepted? Join my Poker Power game on %{date}—let's see who wins!",
    "defaultHostName": "Host",
    "deleteModal": {
      "title": "Delete scheduled game?",
      "message": "This will cancel the schedule. Invited players will no longer be able to join.",
      "confirm": "Delete"
    }
  },
  "loungeShareCard": {
    "title": "Share the Lounge",
    "subtitle": "Invite friends via messages or email.",
    "joinCodeLabel": "JOIN CODE",
    "qrCode": "QR Code",
    "rotateCode": "Rotate Code",
    "enterLounge": "Enter the Lounge",
    "rotateAlert": {
      "title": "Rotate Code",
      "message": "This will invalidate the current join code. Continue?",
      "cancel": "Cancel",
      "confirm": "Rotate"
    },
    "rotateError": "Failed to rotate code"
  },
  "createLoungeScreen": {
    "loungeNameLabel": "Lounge name",
    "loungeNamePlaceholder": "Lounge name",
    "shortDescriptionLabel": "Short description (optional)",
    "shortDescriptionPlaceholder": "A short tagline for your lounge...",
    "loungeAvatarLabel": "Lounge avatar",
    "tableColorLabel": "Table color",
    "createButton": "Create Lounge",
    "creating": "Creating...",
    "createError": "Failed to create lounge"
  },
  "webNotificationPrompt": {
    "title": "Stay in the loop",
    "body": "Enable push notifications to get alerts for live games, community events, and your daily poker challenge.",
    "enableButton": "Enable Notifications",
    "dismissButton": "Not now"
  },
  "loungeScheduledGamesScreen": {
    "title": "Edit Scheduled Games",
    "createGame": "Create Game",
    "empty": "No scheduled games yet."
  },
  "createGameV2": {
    "title": "Create Game",
    "startGame": "Start Game",
    "scheduleGame": "Schedule Game",
    "tabs": {
      "solo": "Solo",
      "group": "Group"
    },
    "solo": {
      "gameName": "Game Name",
      "gameNamePlaceholder": "My First Game",
      "bots": "Bots",
      "botSkill": "Bot Skill",
      "appliedAutomatically": "APPLIED AUTOMATICALLY",
      "startingChips": "Starting Chips",
      "blinds": "Blinds",
      "turnClock": "Turn Clock",
      "blindIncreases": "Blind Increases",
      "blindIncreasesInterval": "Blind Increase Interval",
      "customize": "Customize",
      "startingBlind": "Starting Blind",
      "advisor": "Advisor",
      "chipsRequired": "Starting Chips must be at least 2x the Starting Blind",
      "reset": "Reset",
      "tooltips": {
        "bots": "Number of computer-controlled players in your game.",
        "botSkill": "Difficulty level of the bot players.",
        "startingBlind": "The initial big blind amount for the game.",
        "advisor": "Shows suggested actions during your turn."
      }
    },
    "secondsCount": {
      "one": "1 sec",
      "other": "%{count} sec"
    },
    "secondsCount_web": {
      "one": "1 sec",
      "other": "%{count} sec"
    },
    "none": "None",
    "minutesCount": {
      "one": "1 min",
      "other": "%{count} min"
    },
    "minutesCount_web": {
      "one": "1 min",
      "other": "%{count} min"
    },
    "group": {
      "gameName": "Game Name",
      "gameNamePlaceholder": "My First Game",
      "appliedAutomatically": "APPLIED AUTOMATICALLY",
      "startingChips": "Starting Chips",
      "blinds": "Blinds",
      "turnClock": "Turn Clock",
      "blindIncreases": "Blind Increases",
      "blindIncreasesInterval": "Blind Increase Interval",
      "rebuy": "Rebuy",
      "privateGame": "Private Game",
      "off": "Off",
      "on": "On",
      "customize": "Customize",
      "startingBlind": "Starting Blind",
      "allowRebuy": "Rebuy",
      "allowRebuySubtitle": "Mid-table top-up",
      "advisor": "Advisor",
      "scheduleForLater": "Schedule for later",
      "date": "Date",
      "time": "Time",
      "nameRequired": "Game name required",
      "chipsRequired": "Starting Chips must be at least 2x the Starting Blind",
      "reset": "Reset",
      "tooltips": {
        "startingBlind": "The initial big blind amount for the game.",
        "advisor": "Shows suggested actions during your turn."
      }
    }
  }
}
